import 'promise-polyfill/src/polyfill';
import './polyfills/required';
import lazyload from './lazyload.js';
import newsloader from './newsloader.js';
import equaliser from './equaliser';
import civicCookie from './civic-cookie';
import slider from './slider';

slider({
  container: '.news-slider',
  responsive: {
    0: {
      items: 1,
      gutter: 0,
    },
    576: {
      items: 2,
      gutter: 10,
    },
    768: {
      items: 3,
      gutter: 10,
    },
    992: {
      items: 4,
      gutter: 10,
    },
  },
  hideBtnClass: 'd-none',
});

civicCookie();

(function() {
  const el = document.querySelector('[href="#navPrimary__overlay"]');

  if (el !== null) {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const x = document.getElementById('navPrimary__overlay');
      x.classList.toggle('navPrimary__overlay-show');
    });
  }
})();


const str2 = '[data-youtube-id]';
const ytEls2 = document.querySelectorAll(str2);
if (ytEls2.length > 0) {
  import(/* webpackChunkName: "youtube-player" */ './youtubePlayer')
      .then(({default: setup}) => {
        setup(str2);
      });
};

lazyload();

/** *
 * @todo
 *
 * Add functionality for orientation change/ screen resize
 *
 */

newsloader();

equaliser();

(function() {
  const navSearch = document.querySelector('.nav-block-link-search');
  const searchBar = document.querySelector('#search-bar');
  const main = document.getElementById('main');

  if (navSearch && searchBar) {
    navSearch.addEventListener('click', (event) => {
      event.preventDefault();

      searchBar.classList.toggle('search-bar--show');
      main.classList.toggle('search-bar--active');
    });

    main.addEventListener('click', (event) => {
      searchBar.classList.remove('search-bar--show');
      main.classList.remove('search-bar--active');
    });
  }
})();


// banner alert
(function() {
  // get the banner element
  const banner = document.getElementById('banner-alert');

  const cookies = document.cookie.split('; ');
  // if banner_dismissed cookie is not set then show the banner alert
  if (!cookies.includes('banner_dismissed=true')) {
    banner.classList.remove('d-none');
  };

  // target the close button on the alert
  const bannerClose = document.querySelector('#banner-alert button.close');

  // when the alert close is clicked then set the cookie
  if (bannerClose !== undefined && bannerClose !== null) {
    bannerClose.addEventListener('click', function(event) {
      const c = 'banner_dismissed=true; SameSite=Lax; expires=Session; path=/';
      document.cookie = c;
    });
  }
})();
